import { render, staticRenderFns } from "./DropdownShop.vue?vue&type=template&id=4c263372&scoped=true&"
import script from "./DropdownShop.vue?vue&type=script&lang=js&"
export * from "./DropdownShop.vue?vue&type=script&lang=js&"
import style0 from "./DropdownShop.vue?vue&type=style&index=0&id=4c263372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c263372",
  null
  
)

export default component.exports